export const EXPLORE_MODES = {
  VISUAL: {
    label: "Visual",
    value: "visual",
  },
  TABLE: {
    label: "Table",
    value: "table",
  },
  COMPARE: {
    label: "Compare",
    value: "compare",
  },
  SEARCH: {
    label: "Search",
    value: "search",
  },
};
